<template>
<div class="main">
    <div class="card-header d-flex align-items-center am-main-box am-main-top-box">
        <div class="mr-auto am-main-box-title am-main-top-box-title">Commission Filing</div>
        <old-link class="ml-1" to="downloadCommissions.php" title="Import Commissions">
            <svg-icon icon="import" title="Import Commissions" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </old-link>
        <a class="ml-1" v-if="!favorite" href="#" v-on:click="toggle()" title="Favorite" @click.prevent="favoriteButton">
          <svg-icon icon="unfavorite" title="Favorite" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <a class="ml-1" v-if="favorite" href="#" v-on:click="toggle()" title="UnFavorite" @click.prevent="favoriteButton">
          <svg-icon icon="favorite" title="UnFavorite" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <a class="ml-1" href="#" title="Help" @click.prevent="startHelpTour">
          <svg-icon icon="help" title="Help" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <old-link class="back-button" to="#/admin" title="Back">
          <svg-icon icon="back" title="Back" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </old-link>
        <router-link class="ml-1" :to="{name: 'commissions.create'}" title="Create">
          <svg-icon icon="add" title="Create" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </router-link>
        <a class="ml-1" href="#" title="Commission Reconciliation Part 1" @click.prevent="video()">
          <svg-icon icon="video" title="Commission Reconciliation Part 1" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <a class="ml-1" href="#" title="Commission Reconciliation Part 2" @click.prevent="secondVideo()">
          <svg-icon icon="video" title="Commission Reconciliation Part 2" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
    </div>
    <b-navbar class="table-background">
        <b-navbar-nav class="mr-auto">
            <div class="align-items-end">
                <ul class="am-main-tabs navbar-nav navbar-expand-lg">
                    <router-link class="system-font" :to="{query: {status: 0}}" tag="li" exact="exact" id="activeBtn"><a class="btn btn-sm btn-primary" ref="activeBtn">Active <div class="badge">{{counts.active}}</div></a></router-link>
                    <router-link class="system-font" :to="{query: {status: 1}}" tag="li" exact="exact" id="archivedBtn"><a class="btn btn-sm btn-primary">Archived <div class="badge">{{counts.archived}}</div></a></router-link><button class="btn btn-sm btn-primary inactive system-font" @click.prevent="setEnableMerging" id="mergeBtn" v-if="!enableMerging">Enable Merging</button>
                    <button
                        class="btn btn-sm btn-danger system-font" @click.prevent="setDisableMerging" id="mergeBtn1" v-if="enableMerging">Disable Merging</button>
                </ul>
            </div>

        </b-navbar-nav>
    </b-navbar>
    <div class="card-body position-relative table-background"><template>
      <div class="d-flex justify-content-between" id="top-div">
        <span class="text-left active-title">{{ archived ? "Archived" : "Active"}} Files</span>
        <pageItems :pagination="pagination" @setPageSize="setPageSize" v-if="files.length !== 0"></pageItems></div>
      <div class="border border-info" id="border-div">
        <div class="table-responsive">
          <table class="table table-sm table-hover system-table table-borderless">
            <thead class="thead-dark text-left">
            <tr><th class="text-center system-font" v-if="enableMerging">From</th>
              <th class="text-center system-font" v-if="enableMerging">To</th>
              <th class="text-center system-font viewTableHeader">V</th>
              <th class="text-center system-font deleteTableHeader" v-if="!archived">D</th>
              <th class="text-center system-font" v-if="!archived">P</th>
              <th class="text-center system-font archiveTableHeader" v-if="!archived">A</th>
              <th class="text-center system-font" v-if="archived">U</th>
              <th class="system-font" title="Pending">Pending</th>
              <th class="system-font" title="Staged">Staged</th>
              <th class="system-font" title="Settled">Settled</th>
              <th class="system-font" title="Forwarded">Forwarded</th>
              <th class="system-font">Company</th>
              <th class="text-right system-font">Total Amount</th>
              <th class="system-font">Report Date</th>
              <th class="system-font">Start</th><th class="system-font">End</th>
              <th class="system-font">Deposit Date</th><th class="system-font">Created By</th></tr></thead>
            <tbody>
            <tr v-for="file in files" :key="file.id">
              <td class="system-font" v-if="enableMerging">
                <input type="checkbox" v-model="file.from" :disabled="disableFromCheckbox(file.id)"/></td>
              <td class="system-font" v-if="enableMerging">
                <input type="checkbox" v-model="file.to" :disabled="disableToCheckbox(file.id)"/></td>
              <td class="text-center">
                <router-link :to="{name: 'commissions.reconcile.file', params: {id: file.id}}" title="View">
                  <svg-icon icon="view" title="View" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon>
                </router-link>
              </td>
              <td class="text-center" v-if="!archived">
                <a @click.prevent="confirmDeleteFile(file.id)" href="" title="Delete" :style="!file.deletable ? 'display:none' : ''">
                  <svg-icon icon="delete" title="Delete" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
              </td>
              <td class="text-center" v-if="!archived">
                <a @click.prevent="postFiles(file.id)" href="" title="Post" :style="file.details.settled === 0 ? 'display:none' : ''">
                  <svg-icon icon="forward" title="Post" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
              </td>
              <td class="text-center" v-if="!archived">
                <a @click.prevent="archiveFiles(file.id)" href="" title="Archive">
                  <svg-icon icon="hide" title="Archive" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
              </td>
              <td class="text-center" v-if="archived">
                <a @click.prevent="unarchiveFiles(file.id)" href="" title="Un-Archive">
                  <svg-icon icon="unhide" title="Un-Archive" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
              </td>
              <td class="text-left system-font">{{ file.details.pending | number(0) }}</td>
              <td class="text-left system-font">{{ file.details.staged | number(0) }}</td>
              <td class="text-left system-font">{{ file.details.settled | number(0) }}</td>
              <td class="text-left system-font">{{ file.details.forwarded | number(0) }}</td>
              <td class="text-left system-font">{{ file.company }}</td>
              <td class="text-right system-font">${{ file.total | number }}</td>
              <td class="text-left system-font">{{ file.created }}</td>
              <td class="text-left system-font">{{ file.start }}</td>
              <td class="text-left system-font">{{ file.end }}</td>
              <td class="text-left system-font">{{ file.deposited }}</td>
              <td class="text-left system-font">{{ file.creator }}</td></tr></tbody></table></div>
        <div class="text-right" id="page-navigator">
          <pageNavigator :pagination="pagination" @setPage="fetchPage" @setPageSize="setPageSize" v-if="files.length !== 0"></pageNavigator></div>
        <router-link :to="{name: 'commissions.merge', params: {fromIds: fromIds, toIds: toIds}}">
          <button class="btn btn-sm btn-primary system-font" v-if="enableMerging &amp;&amp; toIds.length === 1 &amp;&amp; fromIds.length &gt; 0" id="mergeSelectedBtn">Merge Selected</button>
        </router-link>
      </div>
    </template>
<div class="alert alert-danger" role="alert" v-show="error">{{ error }}</div>
</div>
<div class="am-main-box am-main-bottom-box"></div>
  <v-tour name="helpTour" :steps="steps"/>
  <play-video v-show="showVideoModal" :videoCode="videoCode" :videoType="videoType"/>
<modal name="CommissionDelete" classes="am-vue-modal" :clickToClose="false" height="auto" width="400px" :pivotY="0.4" :adaptive="true">
  <message-popup :confirmDelete="true" @CloseModal="deleteCommission" modal-name="CommissionDelete"
                 :errors="messageString" :messageHeader="confirmation"/>
 </modal>

  <modal name="Archive" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3" height="150px" width="400px">
    <archive :data="hideModalData" name="commission file" @toggleAction="toggleHideArchive" @closeAction="closeHideModal"></archive>
  </modal>

  <modal name="CommissionHide" classes="am-vue-modal" :clickToClose="false" height="auto" width="400px" :pivotY="0.4" :adaptive="true">
    <message-popup :confirmDelete="true" @CloseModal="deleteCommission" modal-name="CommissionHide"
                   :errors="messageString" :messageHeader="confirmation"/>
  </modal>
</div>
</template>

<script>
import OldLink from '@/components/OldLink'
import Archive from '../../components/Archive.vue'
import FileCreateForm from './partials/FileCreateForm'
import Pagination from './partials/SimplePagination'
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import PageItems from './partials/PageItems'
import PageNavigator from './partials/PageNavigator'
import PlayVideo from '@/components/PlayVideo.vue'
import MessagePopup from '@/components/MessagePopup.vue'
import api from '@/http'

export default {
  name: 'Reconcile',

  mixins: [makesAjaxRequests],

  components: {
    Archive,
    'hideConfirmation': Archive,
    FileCreateForm,
    Pagination,
    OldLink,
    PageItems,
    PlayVideo,
    MessagePopup,
    PageNavigator
  },

  props: {
    status: {
      type: Number
    }
  },

  data () {
    return {
      deleteCommissionId: 0,
      pagination: {},
      hideModalData: {},
      testconfirmation: 'Alert',
      files: [],
      counts: {},
      showVideoModal: false,
      videoCode: '181821236',
      videoType: 'vimeo',
      confirmation: 'Confirmation',
      messageString: 'Are you SURE you want to delete this commission file?',
      favoriteLoading: true,
      filter: {
        status: 0
      },
      enableMerging: false,
      steps: [
        {
          target: '.viewTableHeader',
          content: 'Opens the file processing screen.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.deleteTableHeader',
          content: 'Deletes the file.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.archiveTableHeader',
          content: 'Archiving a file simply moves it to the archived tab, the only purpose archiving ' +
            'serves is to reduce the number of items in the "current" tab.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '#archivedBtn',
          content: 'Archived tab is where the archived files can be found',
          params: {
            placement: 'right'
          }
        }
      ]
    }
  },
  computed: {
    archived () {
      return this.filter.status === 1
    },

    selected () {
      return this.files.filter(i => i.selected)
    },

    selectedIds () {
      return this.selected.map(i => i.id)
    },


    allSelected: {
      get () {
        return this.files.length > 0 && this.selected.length === this.files.length
      },
      set (val) {
        this.files.map(d => { d.selected = val })
      }
    },

    allowDelete () {
      return this.selected.length > 0 && this.selected.filter(f => !f.deletable).length === 0
    },

    allowPost () {
      return this.selected.length > 0 && this.selected.filter(f => !f.postable).length === 0
    },

    from () {
      return this.files.filter(i => i.from)
    },

    to () {
      return this.files.filter(i => i.to)
    },

    fromIds () {
      return this.from.map(i => i.id)
    },

    toIds () {
      return this.to.map(i => i.id)
    }
  },

  asyncComputed: {
    favorite: {
      get () {
        let self = this
        return api.makeRequest('reports/favorite/admin/commission_uiReconciliation').then(
          (data) => {
            self.favoriteLoading = false
            return data.data.results
          }
        )
      },
      default: false
    }
  },

  methods: {
    fetchPage (page) {
      let params = {
        page: page || this.pagination.current_page,
        status: this.filter.status,
        count: this.pagination.per_page
      }

      this.ajaxCall(this.$http.get('commission/file', { params }).then(resp => {
        this.pagination = resp.data.pagination
        this.counts = resp.data.counts
        this.$emit('setLoadingBar', 100)
        this.files = resp.data.data.map(file => {
          return {
            ...file,
            selected: false
          }
        })
      }))
    },

    deleteCommission () {
      let self = this
      let ids = this.deleteCommissionId
      this.ajaxCall(this.$http.post(`commission/file/delete`, { ids }).then(resp => {
        console.info(resp)
        this.fetchPage()
      }))
        .then(function (response) {
          self.fetchPage()
          console.log('response', response)
        }).catch(function (error) {
        console.log(error)
      })
    },

    confirmDeleteFile (id) {
      this.deleteCommissionId = id
      this.$modal.show('CommissionDelete')
    },

    refreshList() {
      this.$asyncComputed.favorite.update()
    },

    setPageSize (size) {
      let params = {
        count: size,
        status: this.filter.status
      }

      this.ajaxCall(this.$http.get('commission/file', { params }).then(resp => {
        this.pagination = resp.data.pagination
        this.counts = resp.data.counts
        this.files = resp.data.data.map(file => {
          return {
            ...file,
            selected: false
          }
        })
      }))
    },
    closeHideModal() {
      this.$modal.hide('Archive')
    },
    toggleHideArchive(){
      let ids= this.hideModalData.id
      if(this.hideModalData.active === 0){
        this.ajaxCall(this.$http.post('commission/file/unarchive', { ids }).then(resp => {
          console.info(resp)
          this.fetchPage()
        }))
      } else {
        this.ajaxCall(this.$http.post(`commission/file/archive`, {ids}).then(resp => {
          console.info(resp)
          this.fetchPage()
        }))
      }
      this.closeHideModal()
    },
    archiveFiles (ids) {
      this.hideModalData.id =ids
      this.hideModalData.active = 1
      this.$modal.show('Archive')
    },

    unarchiveFiles (ids)
    {
      this.hideModalData.id =ids
      this.hideModalData.active = 0
      this.$modal.show('Archive')
    },

    postFiles (ids) {
      this.ajaxCall(this.$http.post(`commission/file/post`, { ids }).then(resp => {
        console.info(resp)
        this.fetchPage()
      }))
    },

    favoriteButton () {
      var self = this
      if (self.favoriteLoading === false) {
        self.favoriteLoading = true
        if (!this.favorite) {
          api.postLegacyRequest(`lockReport.php?Action=favoriteLock&reportName=admin/commission_uiReconciliation`, 'Commission Reconciliation-1').then(function () {
            self.$asyncComputed.favorite.update()
          })
        } else {
          api.postLegacyRequest(`lockReport.php?Action=favoriteUnlock&reportName=admin/commission_uiReconciliation`, 'Commission Reconciliation-1').then(function () {
            self.$asyncComputed.favorite.update()
          })
        }
      }
    },

    mergeFiles () {
      var fromIds = this.fromIds
      var toIds = this.toIds
      var ids = fromIds.concat(toIds)
      this.ajaxCall(this.$http.post(`commission/file/merge`, { ids }).then(resp => {
        console.info(resp)
        this.fetchPage()
      }))
    },

    submitForm (event) {
      event.preventDefault()
      this.$refs.createForm.submit()
    },

    fileCreated (file) {
      this.$router.push({
        name: 'commissions.reconcile.file',
        params: { id: file.id }
      })
    },

    setEnableMerging () {
      this.enableMerging = true
    },

    setDisableMerging () {
      this.enableMerging = false
    },

    disableToCheckbox (id) {
      return ((this.toIds.length === 1 && this.toIds[0] !== id) || this.fromIds.includes(id))
    },

    disableFromCheckbox (id) {
      return (this.toIds.length === 1 && this.toIds[0] === id)
    },

    video: function () {
      this.showVideoModal = true
      this.videoCode = '181821236'
      this.$modal.show('playVideo')
    },

    secondVideo: function () {
      this.showVideoModal = true
      this.videoCode = '181821523'
      this.$modal.show('playVideo')
    },

    startHelpTour () {
      this.$refs.activeBtn.click()
      this.$tours['helpTour'].start()
    }
  },

  watch: {
    'status': {
      immediate: true,
      handler: function (val) {
        this.filter.status = Number.parseInt(this.status)
        this.fetchPage(1)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .controls.disabled
    opacity: .2
    cursor: not-allowed
    *
      pointer-events: none

  .back-button
    margin-left: 5px

  .inactive
    background-color: #9aca63

  .inactive:hover
    background-color: #4f7128

  #activeBtn, #archivedBtn, #mergeBtn
    border-color: darkgray

  .active-title
    padding: 0 6px 4px
    color: #2777a3
    font-weight: 700
    font-family: Verdana, sans-serif
    margin-left: -7px
    margin-top: 15px

  #mergeSelectedBtn
    border-color: white
    margin-top: -70px

  .system-font
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px

  .title
    font-weight: bold
    margin-bottom: 10px

  .btn
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0

  .system-table
    tr:nth-child(even)
      background: #ECECEC
    tr:nth-child(odd)
      background: #f4f4f4

  .am-main-box
    height: 37px
    font-size: 11px
    font-weight: bold
    padding-right: 5px
    border-radius: 0px

  .am-main-box-title
    float: left
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px
    font-weight: bold

  .table-background
    background-color: #f4f4f4

  #border-div
    margin: 3px -1px -10px -1px
    padding: 1px 1px 15px 1px

  #page-navigator
    margin-right: 10px

  #top-div
    margin-top: -20px

  .bottom
    border-radius: 0 0 4px 4px

  .ui-state-active a
    background: #2777a3

  .main
    border: 1px solid #AAAAAA
    margin: 12px 0 30px 12px
    background-color: #F6F6F6
    min-width: 450px
    float: left

    .v--modal-overlay
      background-color: rgba(0,0,0,0.6) !important

</style>
